import { m } from "@vega-core/paraglide/messages";

import { PermissionsTable } from "./PermissionsTable";

export const PermissionsTablePage = () => (
  <div className="flex flex-col gap-4">
    <h2 className="body-extra-large-semibold">
      {m.userManagement_help_rolesPermissionsTable()}
    </h2>
    <div className="flex flex-col gap-8">
      <div className="body-base-regular text-text/secondary">
        {m.userManagement_help_rolesPermissionsTableDescription()}
      </div>
      <PermissionsTable />
    </div>
  </div>
);
